import { ArrowLeftOutlined } from "@ant-design/icons";
import { useRouter } from "@tanstack/react-router";
import { Button } from "antd";
import { useCallback } from "react";

export function BtnVoltar() {
	const router = useRouter();

	const handleNavigation = useCallback(() => {
		router.history.back();
	}, [router]);

	return (
		<Button onClick={handleNavigation} type="link">
			<ArrowLeftOutlined />
			<span style={{ fontSize: "16px" }}>Voltar</span>
		</Button>
	);
}
